import React, { useState } from 'react';
import './Contact.css';

const WA = '919445879508';
const PH = '9445879508';

export default function Contact() {
  const [form, setForm] = useState({ name:'', phone:'', email:'', vehicle:'', date:'', passengers:'', message:'' });
  const [sent, setSent] = useState(false);

  const change = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const submit = e => {
    e.preventDefault();
    const msg = `Hi Maggi Cabs!%0A%0AName: ${form.name}%0APhone: ${form.phone}%0AVehicle: ${form.vehicle}%0ADate: ${form.date}%0APassengers: ${form.passengers}%0AMessage: ${form.message}`;
    window.open(`https://wa.me/${WA}?text=${msg}`, '_blank');
    setSent(true);
  };

  return (
    <div className="contact-page page-enter">
      <div className="inner-hero" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1501854140801-50d01698950b?w=1600&q=80')" }}>
        <div className="inner-hero__overlay" />
        <div className="container inner-hero__content">
          <p className="eyebrow">Get in Touch</p>
          <h1 className="display-title light">Book Your Trip</h1>
          <div className="amber-line" />
          <p>Call, WhatsApp, or fill the form — we'll get back to you instantly!</p>
        </div>
      </div>

      <section className="section-pad container">
        <div className="contact-grid">

          {/* Contact Info */}
          <div className="contact-info">
            <p className="eyebrow">Reach Us Directly</p>
            <h2 className="display-title" style={{fontSize:'2rem'}}>Talk to Anbu Kumar</h2>
            <div className="amber-line" />

            <a href={`tel:+91${PH}`} className="contact-cta-card call">
              <span className="contact-cta-icon">📞</span>
              <div>
                <strong>Call Now</strong>
                <span>+91 {PH}</span>
                <small>Available 24/7</small>
              </div>
            </a>

            <a href={`https://wa.me/${WA}?text=Hi%20Anbu%20Kumar!%20I%20want%20to%20book%20a%20trip.`}
               target="_blank" rel="noreferrer" className="contact-cta-card whatsapp">
              <span className="contact-cta-icon">💬</span>
              <div>
                <strong>WhatsApp</strong>
                <span>+91 {PH}</span>
                <small>Instant reply</small>
              </div>
            </a>

            <div className="contact-details">
              {[
                { icon:'📍', label:'Pick-up Point', val:'Kodai Road Railway Station, Dindigul, Tamil Nadu' },
                { icon:'🏔️', label:'Destination',   val:'Kodaikanal & all major hill stations' },
                { icon:'⏰', label:'Available',     val:'24 Hours, 7 Days a Week, 365 Days' },
                { icon:'🚗', label:'Fleet',         val:'4, 7, 12 & 25 Seater Vehicles' },
              ].map(d => (
                <div key={d.label} className="contact-detail-item">
                  <span>{d.icon}</span>
                  <div>
                    <strong>{d.label}</strong>
                    <p>{d.val}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* <div className="contact-map-placeholder">
              <p>📍 Kodai Road, Dindigul District, Tamil Nadu</p>
              <small><a href="https://www.google.com/maps/place/Maggi+Cabs/@10.1783257,77.9103643"></a></small>
            </div> */}
          </div>

          {/* Booking Form */}
          <div className="booking-form-wrap">
            <p className="eyebrow">Quick Booking</p>
            <h2 className="display-title" style={{fontSize:'2rem'}}>Send Your Details</h2>
            <div className="amber-line" />
            <p className="booking-note">Fill the form — we'll send it directly to our WhatsApp!</p>

            {sent ? (
              <div className="form-success">
                <span>✅</span>
                <h3>Booking Request Sent!</h3>
                <p>Your details have been sent to Anbu Kumar on WhatsApp. Expect a reply very shortly!</p>
                <button className="btn-primary" style={{marginTop:'1rem'}} onClick={() => setSent(false)}>Send Another</button>
              </div>
            ) : (
              <form className="booking-form" onSubmit={submit}>
                <div className="form-row">
                  <div className="form-group">
                    <label>Your Name *</label>
                    <input name="name" required placeholder="Full name" value={form.name} onChange={change} />
                  </div>
                  <div className="form-group">
                    <label>Phone Number *</label>
                    <input name="phone" required placeholder="+91 XXXXX XXXXX" value={form.phone} onChange={change} />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Vehicle Type *</label>
                    <select name="vehicle" required value={form.vehicle} onChange={change}>
                      <option value="">Select vehicle</option>
                      <option>4-Seater Car</option>
                      <option>7-Seater SUV</option>
                      <option>12-Seater Van</option>
                      <option>25-Seater Mini Coach</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Travel Date *</label>
                    <input name="date" type="date" required value={form.date} onChange={change} />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>No. of Passengers</label>
                    <input name="passengers" type="number" min="1" placeholder="e.g. 4" value={form.passengers} onChange={change} />
                  </div>
                  <div className="form-group">
                    <label>Tour Type</label>
                    <select name="message" value={form.message} onChange={change}>
                      <option value="">Select tour type</option>
                      <option>Honeymoon Package</option>
                      <option>Family Trip</option>
                      <option>Group Tour</option>
                      <option>Sightseeing Tour</option>
                      <option>Station Pickup / Drop</option>
                      <option>Custom Package</option>
                    </select>
                  </div>
                </div>
                <div className="form-group">
                  <label>Additional Message</label>
                  <textarea name="message" rows="4" placeholder="Any special requirements, pickup time, etc..."
                    value={form.message} onChange={change} />
                </div>
                <button type="submit" className="btn-primary" style={{width:'100%',justifyContent:'center',padding:'1rem'}}>
                  💬 Send Booking via WhatsApp
                </button>
              </form>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
